define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/aofl-list-option/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/aofl-list-option/1.0.0/index.css',
  'readingiq-src/js/riq-js/aofl-select-list/1.0.0/index'
], function directive(app, html, css) {
  app.registerComponent('aoflListOption', {
    transclude: true,
    require: {
      aoflSelectList: '^aoflSelectList'
    },
    bindings: {
      value: '@',
      selected: '@?',
      selectedValue: '@?',
      disabled: '<?'
    },
    controller: 'AoflListOptionController',
    template: html
  });

  app.registerController('AoflListOptionController', [
    '$scope',
    '$element',
    'compileService',
    function AoflListOptionController($scope, $element, compileService) {
      var vm = this;

      vm.$onInit = function onInit() {
        this.aoflSelectList.addOption(this);
      };

      vm.select = function select() {
        this.aoflSelectList.selectionUpdated(this);
      };

      vm.updateSelectedAttribute = function updateSelectedAttribute() {
        if (this.selected === 'true') {
          $element[0].setAttribute('selected', 'true');
        } else {
          $element[0].removeAttribute('selected');
        }
      };

      vm.$onChanges = function(changeObj) {
        if (
          changeObj.selectedValue &&
          changeObj.selectedValue.currentValue !==
            changeObj.selectedValue.previousValue
        ) {
          if (vm.value === vm.selectedValue) {
            vm.select();
          }
        }
      };

      $scope.$watch(
        function() {
          return vm.selected;
        },
        function() {
          if (vm.value === vm.selectedValue) {
            vm.select();
          }
        }
      );

      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
